import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { UserService } from 'src/app/services/user.service';
import { Options } from 'select2';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

declare var bootstrap: any;

@Component({
  selector: 'app-extracoes',
  templateUrl: './extracoes.component.html',
  styleUrls: ['./extracoes.component.css']
})
export class ExtracoesComponent implements OnInit {
  isOK = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement!: DataTableDirective;

  dtOptions: DataTables.Settings = {};

  cadastroFrm!: cadastroData;

  logs: Array<logsData> = [];

  modalCadastrar: any;
  modalLog: any;

  options1!: Options;

  periodos: Array<string> = [];

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {
    if (this.userService.checarPermissao('2')[0]) {
      this.isOK = true;
    } else {
      return;
    }

    const today = new Date();
    for (let i = (today.getUTCFullYear() - 10); i <= today.getUTCFullYear(); i++) {
      this.periodos.push(i.toString());
    }

    this.cadastroFrm = {
      loading: false,
      data: {
        cliente: -1,
        senha: '',
        instrucoes: {
          periodo: false,
          inicio: this.periodos[this.periodos.length - 6],
          fim: this.periodos[this.periodos.length - 1],
          darf: false,
          dctf: false,
          mit: false,
          dirf: false,
          efd: false,
          ecd: false,
          ecf: false,
          icms: false,
          converter: false,
          dashboard: false
        }
      }
    }

    this.options1 = {
      allowClear: true,
      placeholder: 'Selecione um Cliente',
      ajax: {
        type: 'POST',
        url: environment.apiEndpoint + 'select-cliente',
        dataType: 'json',
        contentType: "application/json",
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        delay: 250,
        data: (params) => {
          return JSON.stringify({
            q: params.term,
          });
        },
        error: (xhr: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        },
        processResults: (data) => {
          return {
            results: data,
          };
        },
        cache: true,
      },
      language: "pt-BR",
      dropdownParent: $('#cadastrar')
    };

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
    }

    this.modalCadastrar = new bootstrap.Modal(
      document.getElementById('cadastrar'),
      {
        backdrop: 'static',
      }
    );

    this.modalLog = new bootstrap.Modal(
      document.getElementById('log'),
      {
        backdrop: 'static',
      }
    );

    this.dtOptions = {
      language: this.userService.dataTableLanguage,
      ajax: {
        url: environment.apiEndpoint + 'pedidos-list',
        type: 'POST',
        dataType: 'json',
        contentType: "application/json",
        data: function (d) {
          return JSON.stringify(d);
        },
        headers: {
          Authorization: 'Bearer ' + this.userService.getToken(),
        },
        error: (xhr: any, error: any, code: any) => {
          if (xhr.status === 401) {
            localStorage.removeItem('botway');
            this.router.navigate(['/login']);
          }
        }
      },
      pageLength: 10,
      processing: false,
      serverSide: true,
      columnDefs: [
        { "searchable": false, "targets": [8] },
        { "orderable": false, "targets": [8], },
        { "width": "5%", "targets": 0 },
        { "width": "10%", "targets": 1 },
        { "width": "5%", "targets": 2 },
        { "width": "10%", "targets": 3 },
        { "width": "10%", "targets": 5 },
        { "width": "20%", "targets": 6 },
        { "width": "5%", "targets": 7 },
        { "width": "15%", "targets": 8 },
      ],
      order: [[1, 'desc']],
      rowCallback: (row: Node, data: any[] | object, index: number) => {
        const id = Number($('button:eq(0)', row).attr('row_id'));
        $('button:eq(0)', row).off('click');
        $('button:eq(0)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchDownload(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = '<i class="bi bi-download"></i>'
          }
          call();
        });
        $('button:eq(1)', row).off('click');
        $('button:eq(1)', row).on('click', (obj) => {
          this.Reprocessar(Number(id));
        });
        $('button:eq(2)', row).off('click');
        $('button:eq(2)', row).on('click', (obj) => {
          const call = async () => {
            (obj.currentTarget as any).disabled = true;
            obj.currentTarget.innerHTML = '<span class="spinner-border spinner-border-sm"></span>';
            await this.fetchLog(id);
            (obj.currentTarget as any).disabled = false;
            obj.currentTarget.innerHTML = '<i class="bi bi-search"></i>';
          }
          call();
        });
        return row;
      },
    }
  }

  Reprocessar(id: number) {
    Swal.fire({
      title: 'Reprocessar Pedido?',
      icon: 'warning',
      text: 'O Pedido será recolocado na fila',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Reprocessar',
      heightAuto: false,
      allowOutsideClick: false,
      focusConfirm: false,
      customClass: {
        confirmButton: 'btn-swal',
        cancelButton: 'btn-swal-cancel',
      },
      showLoaderOnConfirm: true,
      preConfirm: () => {
        return new Promise(() => {
          (this.userService.reprocessar(id).subscribe(
            (res: any) => {
              Swal.fire({
                title: 'Sucesso',
                text: res.message,
                icon: 'success',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal',
                },
              });
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.ajax.reload();
              });
            },
            (err: any) => {
              switch (err.status) {
                case 400:
                  Swal.fire({
                    title: 'Erro',
                    text: String(err.error.message),
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
                case 401:
                  localStorage.removeItem('botway');
                  this.router.navigate(['/login']);
                  break;
                case 422:
                  let txt = '';
                  Object.values(err.error.errors).forEach((value: any, index) => {
                    for (let i = 0; i < Array(value).length; i++) {
                      txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                    }
                  });
                  Swal.fire({
                    title: 'Erro',
                    html: txt,
                    icon: 'error',
                    heightAuto: false,
                    allowOutsideClick: false,
                    focusConfirm: false,
                    customClass: {
                      confirmButton: 'btn-swal'
                    },
                  });
                  break;
              }
            }
          ))
        });
      }
    });
  }

  Cadastrar() {
    if (
      this.cadastroFrm.data.instrucoes.darf === false &&
      this.cadastroFrm.data.instrucoes.dctf === false &&
      this.cadastroFrm.data.instrucoes.mit === false &&
      this.cadastroFrm.data.instrucoes.dirf === false &&
      this.cadastroFrm.data.instrucoes.efd === false &&
      this.cadastroFrm.data.instrucoes.ecd === false &&
      this.cadastroFrm.data.instrucoes.ecf === false &&
      this.cadastroFrm.data.instrucoes.icms === false
    ) {
      Swal.fire({
        title: 'Erro',
        html: 'É necessário checar ao menos uma opção',
        icon: 'error',
        heightAuto: false,
        allowOutsideClick: false,
        focusConfirm: false,
        customClass: {
          confirmButton: 'btn-swal'
        },
      });
      return;
    }
    this.cadastroFrm.loading = true;
    this.userService
      .cadastrarPedido(
        this.cadastroFrm.data
      )
      .subscribe(
        (res: any) => {
          Swal.fire({
            title: 'Sucesso',
            text: res.message,
            icon: 'success',
            heightAuto: false,
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              confirmButton: 'btn-swal'
            },
          });
          this.cadastroFrm.data = {
            cliente: -1,
            senha: '',
            instrucoes: {
              periodo: false,
              inicio: this.periodos[0],
              fim: this.periodos[this.periodos.length - 1],
              darf: false,
              dctf: false,
              mit: false,
              dirf: false,
              efd: false,
              ecd: false,
              ecf: false,
              icms: false,
              converter: false,
              dashboard: false
            }
          }
          this.modalCadastrar.hide();
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.ajax.reload();
          });
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
          this.cadastroFrm.loading = false
        },
        () => (this.cadastroFrm.loading = false)
      );
  }

  fetchDownload(id: number) {
    return new Promise((resolve) => {
      this.userService.fetchDownload(id).subscribe(
        (res: any) => {
          window.open(res.link, '_blank')!.focus();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        },
      ).add(() => {
        resolve('');
      });
    });
  }

  fetchLog(id: number) {
    return new Promise((resolve) => {
      this.userService.fetchLog(id).subscribe(
        (res: any) => {
          this.logs = res.log;
          this.modalLog.show();
        },
        (err: any) => {
          switch (err.status) {
            case 400:
              Swal.fire({
                title: 'Erro',
                text: String(err.error.message),
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
            case 401:
              localStorage.removeItem('botway');
              this.router.navigate(['/login']);
              break;
            case 422:
              let txt = '';
              Object.values(err.error.errors).forEach((value: any, index) => {
                for (let i = 0; i < Array(value).length; i++) {
                  txt = txt + '[' + index + '][' + i + ']-> ' + value[i] + '<BR>';
                }
              });
              Swal.fire({
                title: 'Erro',
                html: txt,
                icon: 'error',
                heightAuto: false,
                allowOutsideClick: false,
                focusConfirm: false,
                customClass: {
                  confirmButton: 'btn-swal'
                },
              });
              break;
          }
        },
      ).add(() => {
        resolve('');
      });
    });
  }

  CheckAll(opt: boolean) {
    this.cadastroFrm.data.instrucoes = {
      periodo: this.cadastroFrm.data.instrucoes.periodo,
      inicio: this.cadastroFrm.data.instrucoes.inicio,
      fim: this.cadastroFrm.data.instrucoes.fim,
      darf: opt,
      dctf: opt,
      mit: opt,
      dirf: opt,
      efd: opt,
      ecd: opt,
      ecf: opt,
      icms: opt,
      converter: this.cadastroFrm.data.instrucoes.converter,
      dashboard: false
    }
  }
}

export interface cadastroData {
  loading: boolean;
  data: {
    cliente: Number;
    senha: string;
    instrucoes: {
      periodo: boolean;
      inicio: string;
      fim: string;
      darf: boolean;
      dctf: boolean;
      mit: boolean;
      dirf: boolean;
      efd: boolean;
      ecd: boolean;
      ecf: boolean;
      icms: boolean;
      converter: boolean;
      dashboard: boolean
    }
  }
}

export interface logsData {
  date: string;
  log: string;
}
